import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiPut } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, Home, Users, Clock, FileCheck, MoreVertical } from 'lucide-react';
import { FaCheckCircle, FaComment, FaEdit, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import UpdateAgreementModal from '../../Modal/UpdateAgreementModal';
import MakeRequirementCompletedModel from '../../Modal/MakeRequirementCompletedModel';

function UserAllConstructionRequirement({ RequirementState, setRequirementState }) {
    const navigate = useNavigate()
    const [Requirements, setRequirements] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const GetUserAllRequirements = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/GetAllUserConstructionRequirement');
            setRequirements(response.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        GetUserAllRequirements();
    }, []);

    const [selectedBids, setSelectedBids] = useState([]);

    const handleToggleContractor = (reqId, bid) => {
        setSelectedBids((prev) => {
            const isSame =
                prev.length > 0 &&
                prev[0].requirementId === reqId &&
                prev[0].contractorId === bid.Contractor;

            if (isSame) {
                return [];
            }
            return [
                {
                    requirementId: reqId,
                    contractorId: bid.Contractor,
                    price: bid.Price,
                    siteVisit: false,
                    ProjectManager: false,
                    Reportfrequency: "Weekly",
                },
            ];
        });
    };


    const handleChangeOption = (reqId, contractorId, field, value) => {
        setSelectedBids((prev) =>
            prev.map((b) =>
                b.requirementId === reqId && b.contractorId === contractorId
                    ? { ...b, [field]: value }
                    : b
            )
        );
    };

    const UserSelectContractors = async () => {
        if (selectedBids.length === 0) return toast.error("Please select at least one contractor");

        const payload = {
            contractors: selectedBids.map((b) => ({
                contractorId: b.contractorId,
                price: b.price,
                siteVisit: b.siteVisit,
                ProjectManager: b.ProjectManager,
                Reportfrequency: b.Reportfrequency,
            })),
        };

        try {
            setIsUploading(true);
            const response = await apiPut(
                `/api/user/UserSelectContractorForRequirement/${selectedBids[0]?.requirementId}`,
                payload
            );
            if (response?.data) {
                toast.success(
                    response?.data?.message ||
                    response?.message ||
                    "Contractors selected successfully!"
                );
                GetUserAllRequirements();
                setIsUploading(false);
            } else {
                toast.error(response?.message || "Failed to select contractors");
                setIsUploading(false);
            }
        } catch (error) {
            console.error("Error selecting contractors:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };

    const [SelectedRequirement, setSelectedRequirement] = useState(null);
    const [UpdateModel, setUpdateModel] = useState(false);


    const OpenUpdateModel = (req) => {
        setUpdateModel(true)
        setSelectedRequirement(req)
    }

    const CloseUpdateModel = () => {
        setUpdateModel(false)
        setSelectedRequirement(null)
    }


    const [AllTracker, setAllTracker] = useState([]);
    const [IsLoading, setIsLoading] = useState(false);

    const fetchAllTracker = async (id) => {
        try {
            setIsLoading(true);
            const response = await apiGet(`api/user/UserGetARequirementTracking/${id}`);
            setAllTracker(response?.data || []);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Error fetching data:", error);
        }
    };


    const [expandedrequirement, setExpandedrequirement] = useState(null);

    const toggleTracker = async (reqId) => {
        if (expandedrequirement === reqId) {
            setExpandedrequirement(null);
            setAllTracker([]);
        } else {
            await fetchAllTracker(reqId);
            setExpandedrequirement(reqId);
        }
    };


    const [openComments, setOpenComments] = useState({});

    const toggleComments = (id) => {
        setOpenComments((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const [commentInputs, setCommentInputs] = useState({});

    const handleCommentSubmit = async (id) => {
        const payload = {
            CommentText: "User -" + " " + commentInputs[id] || "",
        };
        if (!payload.CommentText.trim()) return;

        try {
            setIsUploading(true);
            const response = await apiPost(`/api/user/AddRequirementTrackingComment/${id}`, payload);
            toast.success(response?.data?.message || response?.message);

            setCommentInputs((prev) => ({ ...prev, [id]: "" }));

            fetchAllTracker(expandedrequirement);
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };


    const [CompleteModel, setCompleteModel] = useState(false);

    const OpenCompleteModel = (req) => {
        setSelectedRequirement(req)
        setCompleteModel(true)
    }

    const CloseCompleteModel = () => {
        setCompleteModel(false)
    }





    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };
    const getStatusColor1 = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const ImageModal = () => {
        if (!selectedImage) return null;

        return (
            <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                <div className="relative max-w-4xl max-h-full">
                    <button
                        onClick={() => setSelectedImage(null)}
                        className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
                    >
                        <X size={32} />
                    </button>
                    <img
                        src={selectedImage}
                        alt="Construction site"
                        className="max-w-full max-h-screen object-contain rounded-lg"
                    />
                </div>
            </div>
        );
    };

    const ImageGallery = ({ images }) => {
        if (!images || images.length === 0) return null;

        return (
            <div className="mb-4">
                {images.length === 1 ? (
                    <img
                        src={images[0]}
                        alt="Project"
                        className="h-48 w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity"
                        onClick={() => setSelectedImage(images[0])}
                    />
                ) : (
                    <div className="grid grid-cols-2 gap-2">
                        {images?.slice(0, 4).map((image, index) => (
                            <div key={index} className="relative">
                                <img
                                    src={image}
                                    alt={`Project ${index + 1}`}
                                    className={`w-full object-cover rounded-lg cursor-pointer hover:opacity-90 transition-opacity ${index === 0 ? 'h-32' : 'h-20'
                                        }`}
                                    onClick={() => setSelectedImage(image)}
                                />
                                {index === 3 && images?.length > 4 && (
                                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center text-white font-semibold">
                                        +{images?.length - 4} more
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Construction Requirements
                        </h1>
                        <p className="text-gray-600">
                            Manage and track your construction projects
                        </p>
                    </div>

                    <div className="mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="in_review">In Review</option>
                            <option value="price_provided">Price Provided</option>
                            <option value="approved">Approved</option>
                            <option value="AgreementPending">Agreement Pending</option>
                            <option value="InConstruction">In-Construction</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                </div>
                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : Requirements?.length === 0 ? (
                    <div className="text-center py-20">
                        <Home className="mx-auto h-16 w-16 text-gray-400 mb-4" />
                        <p className="text-xl text-gray-500">No requirements found.</p>
                        <p className="text-gray-400 mt-2">Create your first construction project to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {Requirements?.map((req) => (
                            <div
                                key={req?._id}
                                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                                <ImageGallery images={req?.SitePhotosOrPlan} />
                                <div className="p-6">
                                    <div className="flex justify-between items-start mb-4">
                                        <h3 className="text-xl font-bold text-gray-900">{req?.ProjectType}</h3>
                                        <div className="flex items-center gap-2">
                                            <span
                                                className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(req?.Status)}`}
                                            >
                                                {req?.Status}
                                            </span>
                                            <button
                                                onClick={() => navigate(`/RequirementDetail/${req?._id}`)}
                                                className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                            >
                                                <FaEye className="h-4 w-4" />
                                                Check Details
                                            </button>
                                        </div>
                                    </div>

                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="flex-shrink-0 h-4 w-4 mr-2 mt-0.5" />
                                        <p className="text-sm">
                                            <a
                                                href={`https://www.google.com/maps?q=${req?.Location?.Late},${req?.Location?.Long}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-600 hover:underline"
                                            >
                                                {req?.Location?.Address}, {req?.City}, {req?.State} - {req?.Pincode}
                                            </a>
                                        </p>
                                    </div>
                                    <div className="grid grid-cols-2 gap-4 text-sm">
                                        <div className="flex items-center text-gray-700">
                                            <Home className="h-4 w-4 mr-2 text-blue-500" />
                                            <div>
                                                <p className="font-medium">Size</p>
                                                <p className="text-gray-600">
                                                    {req?.SizeDimension?.Length} x {req?.SizeDimension?.Breadth}{" "} x {req?.NumberOfFloors} ({req?.SizeDimension?.Area}{" "})
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex items-center text-gray-700">
                                            <Users className="h-4 w-4 mr-2 text-green-500" />
                                            <div>
                                                <p className="font-medium">Floors</p>
                                                <p className="text-gray-600">{req?.NumberOfFloors}</p>
                                            </div>
                                        </div>

                                        <div className="flex items-center text-gray-700">
                                            <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                            <div>
                                                <p className="font-medium">Budget</p>
                                                <p className="text-gray-600">{req?.Budget}</p>
                                            </div>
                                        </div>

                                        <div className="flex items-center text-gray-700">
                                            <Clock className="h-4 w-4 mr-2 text-orange-500" />
                                            <div>
                                                <p className="font-medium">Timeline</p>
                                                <p className="text-gray-600">
                                                    {req?.TimelineInMonths} months
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4 pt-4 border-t border-gray-100">
                                        <p className="text-sm text-gray-600 mb-2">
                                            <span className="font-medium">Payment:</span> {req?.PaymentMethod}
                                        </p>
                                    </div>
                                    {req?.AdminSelectedbids?.length > 0 && req?.Status == 'PriceProvided' && (
                                        <div className="mt-6 border-t border-gray-200 pt-5">
                                            <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                                                <Users className="h-5 w-5 mr-2 text-blue-500" />
                                                Contractor Bids
                                            </h4>

                                            <div className="grid gap-4">
                                                {req?.AdminSelectedbids?.map((bid) => {
                                                    const isSelected =
                                                        selectedBids.length > 0 &&
                                                        selectedBids[0].requirementId === req?._id &&
                                                        selectedBids[0].contractorId === bid?.Contractor;

                                                    return (
                                                        <div
                                                            key={bid?._id}
                                                            className={`p-4 border rounded-xl shadow-sm transition-all duration-200 ${isSelected
                                                                ? "border-blue-500 bg-blue-50 ring-2 ring-blue-300"
                                                                : "border-gray-200 hover:shadow-md"
                                                                }`}
                                                        >
                                                            <div className="flex items-center justify-between">
                                                                <div>
                                                                    <h5 className="text-base font-semibold text-gray-800">
                                                                        {bid?.Name}
                                                                    </h5>
                                                                    <p className="text-sm text-gray-500">
                                                                        Price: <span className="font-medium">{bid?.Price}</span>
                                                                    </p>
                                                                </div>

                                                                <input
                                                                    type="checkbox"
                                                                    checked={isSelected}
                                                                    onChange={() => handleToggleContractor(req?._id, bid)}
                                                                    className="h-5 w-5 text-blue-600 rounded"
                                                                />
                                                            </div>

                                                            {isSelected && (
                                                                <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-3">
                                                                    <select
                                                                        value={
                                                                            selectedBids.find(
                                                                                (b) => b.requirementId === req?._id && b.contractorId === bid?.Contractor
                                                                            )?.siteVisit
                                                                                ? "true"
                                                                                : "false"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleChangeOption(
                                                                                req?._id,
                                                                                bid?.Contractor,
                                                                                "siteVisit",
                                                                                e.target.value === "true"
                                                                            )
                                                                        }
                                                                        className="w-full border rounded-lg p-2 text-sm"
                                                                    >
                                                                        <option value="false">Site Visit Form – Professional House: No</option>
                                                                        <option value="true">Site Visit Form – Professional House: Yes</option>
                                                                    </select>

                                                                    <select
                                                                        value={
                                                                            selectedBids.find(
                                                                                (b) => b.requirementId === req?._id && b.contractorId === bid?.Contractor
                                                                            )?.Reportfrequency || "Weekly"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleChangeOption(
                                                                                req?._id,
                                                                                bid?.Contractor,
                                                                                "Reportfrequency",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        className="w-full border rounded-lg p-2 text-sm"
                                                                    >
                                                                        <option value="Daily">Schedule: Daily</option>
                                                                        <option value="Weekly">Schedule: Weekly</option>
                                                                        <option value="Monthly">Schedule: Monthly</option>
                                                                    </select>

                                                                    <select
                                                                        value={
                                                                            selectedBids.find(
                                                                                (b) => b.requirementId === req?._id && b.contractorId === bid?.Contractor
                                                                            )?.ProjectManager
                                                                                ? "true"
                                                                                : "false"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleChangeOption(
                                                                                req?._id,
                                                                                bid?.Contractor,
                                                                                "ProjectManager",
                                                                                e.target.value === "true"
                                                                            )
                                                                        }
                                                                        className="w-full border rounded-lg p-2 text-sm"
                                                                    >
                                                                        <option value="false">Project Manager: No</option>
                                                                        <option value="true">Project Manager: Yes</option>
                                                                    </select>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            <button
                                                disabled={selectedBids.length === 0}
                                                className={`mt-5 px-5 py-2.5 rounded-lg text-sm font-medium shadow ${selectedBids.length > 0
                                                    ? "bg-blue-600 hover:bg-blue-700 text-white"
                                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                    }`}
                                                onClick={() => UserSelectContractors()}
                                            >
                                                Confirm Selection
                                            </button>
                                        </div>
                                    )}
                                    {req?.SelectedContractor?.length > 0 && (
                                        <div className="mt-4">
                                            <h3 className="text-base font-semibold text-green-700 flex items-center gap-2 mb-3">
                                                ✅ Selected Contractors
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                {req?.SelectedContractor?.map((contractor, idx) => (
                                                    <div
                                                        key={contractor?._id || idx}
                                                        className="border border-green-200 rounded-xl bg-white shadow-sm hover:shadow-md transition-all p-4"
                                                    >
                                                        <div className="space-y-2 text-sm">
                                                            <p className="text-gray-600">
                                                                <span className="font-medium text-gray-800">Price:</span>{" "}
                                                                <span className="text-green-700 font-semibold">₹{contractor?.Price}</span>
                                                            </p>
                                                            <p className="text-gray-600">
                                                                <span className="font-medium text-gray-800">Site Visit Form – Professional House:</span>{" "}
                                                                <span className={contractor?.SiteVisit ? "text-green-600 font-semibold" : "text-red-500 font-semibold"}>
                                                                    {contractor?.SiteVisit ? "Yes" : "No"}
                                                                </span>
                                                            </p>
                                                            <p className="text-gray-600">
                                                                <span className="font-medium text-gray-800">Schedule Frequency:</span>{" "}
                                                                <span className="font-semibold">{contractor?.Reportfrequency}</span>
                                                            </p>
                                                            <p className="text-gray-600">
                                                                <span className="font-medium text-gray-800">Project Manager:</span>{" "}
                                                                <span className={contractor?.ProjectManager ? "text-green-600 font-semibold" : "text-red-500 font-semibold"}>
                                                                    {contractor?.ProjectManager ? "Yes" : "No"}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                    {
                                        req?.Status == 'AgreementPending' &&
                                        <div className="mt-4 bg-gray-50 p-4 rounded-lg border text-sm text-gray-700 space-y-3">
                                            <p>
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor1(req?.AdminAgreementRequest)}`}>
                                                    Admin Agreement Request: {req?.AdminAgreementRequest}
                                                </span>
                                            </p>
                                            <p>
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor1(req?.UserAgreementRequest)}`}>
                                                    User Agreement Request: {req?.UserAgreementRequest}
                                                </span>
                                            </p>
                                        </div>
                                    }
                                </div>

                                <div className="px-6 py-4 bg-gray-50 border-t flex justify-between items-center">
                                    <div className="flex items-center text-sm text-gray-500">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        <span>Created: {formatDate(req?.createdAt)}</span>
                                    </div>
                                    {req?.NeedLocalAuthorityApproval && (
                                        <div className="flex items-center text-sm text-red-600 font-medium">
                                            <FileCheck className="h-4 w-4 mr-1" />
                                            <span>Authority Approval</span>
                                        </div>
                                    )}
                                    {req?.Status == 'AgreementPending' && req?.UserAgreementRequest !== "Accepted" &&
                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => OpenUpdateModel(req)}
                                                className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                            >
                                                <FaEdit className="h-4 w-4" />
                                                Update Agreement
                                            </button>
                                        </div>
                                    }
                                    {(req?.Status === "InConstruction") &&
                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={() => OpenCompleteModel(req)}
                                                className="flex items-center gap-1 px-3 py-1 text-sm bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                                            >
                                                <FaCheckCircle className="h-4 w-4" />
                                                Make It Completed
                                            </button>
                                        </div>
                                    }
                                    {(req?.Status === "InConstruction" || req?.Status === "Completed") &&
                                        <button
                                            onClick={() => toggleTracker(req?._id)}
                                            className="text-sm text-blue-600 hover:underline flex items-center gap-2 disabled:opacity-50"
                                            disabled={IsLoading}
                                        >
                                            {IsLoading && expandedrequirement === req?._id ? (
                                                <>
                                                    <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                    <span>Loading...</span>
                                                </>
                                            ) : expandedrequirement === req?._id ? (
                                                "Hide All Tracker"
                                            ) : (
                                                "Show All Tracker"
                                            )}
                                        </button>
                                    }
                                </div>
                                {expandedrequirement === req?._id && (
                                    <div className="p-6 border-t space-y-4 bg-gray-50">
                                        {AllTracker?.length > 0 ? (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                {AllTracker?.map((tracker, idx) => (
                                                    <div
                                                        key={tracker?._id || idx}
                                                        className="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:shadow-md transition"
                                                    >
                                                        <div className="flex justify-between items-center mb-4">
                                                            <h4 className="text-lg font-semibold text-gray-900">{tracker?.Title}</h4>
                                                            <span
                                                                className={`px-3 py-1 text-xs font-semibold rounded-full shadow-sm ${getStatusColor(
                                                                    tracker?.Status
                                                                )}`}
                                                            >
                                                                {tracker?.Status}
                                                            </span>
                                                        </div>
                                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-sm text-gray-700 mb-4">
                                                            <p>
                                                                <span className="font-medium">📄 Description:</span> {tracker?.Description}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">⏳ Start Date:</span> {tracker?.StartDate}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">✅ End Date:</span> {tracker?.EndDate}
                                                            </p>
                                                            <p>
                                                                <span className="font-medium">🕒 Created:</span> {formatDate(tracker?.createdAt)}
                                                            </p>
                                                        </div>
                                                        {tracker?.Media?.length > 0 && (
                                                            <div className="mt-4">
                                                                <p className="text-sm font-semibold text-gray-800 mb-2">📸 Media</p>
                                                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                                                    {tracker?.Media?.map((media, mediaIdx) => (
                                                                        <div
                                                                            key={media?._id || mediaIdx}
                                                                            className="relative group overflow-hidden rounded-lg shadow"
                                                                        >
                                                                            {media?.FileType === "image" ? (
                                                                                <img
                                                                                    src={media?.FileUrl}
                                                                                    alt="Tracker media"
                                                                                    className="w-full h-32 object-cover rounded-lg transform group-hover:scale-105 transition duration-300"
                                                                                />
                                                                            ) : media?.FileType === "video" ? (
                                                                                <video
                                                                                    src={media?.FileUrl}
                                                                                    controls
                                                                                    className="w-full h-32 object-cover rounded-lg bg-black"
                                                                                />
                                                                            ) : (
                                                                                <div className="w-full h-32 flex items-center justify-center bg-gray-200 text-gray-500 rounded-lg text-sm">
                                                                                    Unsupported file
                                                                                </div>
                                                                            )}
                                                                            <p className="text-xs text-gray-500 mt-1">
                                                                                Uploaded: {formatDate(media?.UploadedAt)}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="mt-6">
                                                            <button
                                                                onClick={() => toggleComments(tracker?._id)}
                                                                className="text-sm font-semibold text-blue-600 hover:underline"
                                                            >
                                                                {openComments[tracker?._id]
                                                                    ? "Hide Comments"
                                                                    : `View Comments (${tracker?.Comments?.length || 0})`}
                                                            </button>

                                                            {openComments[tracker?._id] && (
                                                                <>
                                                                    <p className="text-sm font-semibold text-gray-800 mt-3 mb-2">💬 Comments</p>
                                                                    {tracker?.Comments?.length > 0 ? (
                                                                        <div className="space-y-3">
                                                                            {tracker?.Comments?.map((comment, commentIdx) => (
                                                                                <div
                                                                                    key={commentIdx}
                                                                                    className="bg-blue-50 border border-blue-100 p-3 rounded-lg text-sm text-gray-700 shadow-sm"
                                                                                >
                                                                                    <p>{comment?.CommentText}</p>
                                                                                    <p className="text-xs text-gray-500 mt-1">
                                                                                        {formatDate(comment?.CreatedAt)}
                                                                                    </p>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-sm text-gray-500 mt-2">No comments yet</p>
                                                                    )}
                                                                    <div className="mt-4">
                                                                        <textarea
                                                                            value={commentInputs[tracker._id] || ""}
                                                                            onChange={(e) =>
                                                                                setCommentInputs({ ...commentInputs, [tracker._id]: e.target.value })
                                                                            }
                                                                            placeholder="Write your comment..."
                                                                            className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            rows="3"
                                                                            disabled={isUploading}
                                                                        />
                                                                        <button
                                                                            onClick={() => handleCommentSubmit(tracker._id)}
                                                                            className="mt-2 px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center"
                                                                            disabled={isUploading}
                                                                        >
                                                                            <FaComment className="inline-block h-4 w-4 mr-2" />
                                                                            Submit Comment
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="text-sm text-gray-500">No tracking data available</p>
                                        )}

                                    </div>
                                )}
                            </div>
                        ))}

                    </div>
                )}
            </div>
            <UpdateAgreementModal
                agreementData={SelectedRequirement}
                isOpen={UpdateModel}
                onClose={CloseUpdateModel}
                GetUserAllAgreementPendingRequirements={GetUserAllRequirements}
            />
            <MakeRequirementCompletedModel
                requirementData={SelectedRequirement}
                isOpen={CompleteModel}
                onClose={CloseCompleteModel}
                GetUserAllPendingRequirements={GetUserAllRequirements}
            />
            <ImageModal />
        </div>
    );
}

export default UserAllConstructionRequirement;

